import * as aspSettings from './aspSettings';
import * as aspObjects from './aspObjects';
import * as enums from '../common/enums';
import * as units from '../common/units';
import * as utils from '../common/utils';
import { AspObject, ObjectType } from './AspObject';
import { IObjectsPool } from './interfaces';
import { Location } from '../common/Location';
import { stat } from 'fs';
import * as settings from '../common/settings';
import { sensorsLayerID } from './AspMngr';


export class PlotCoreObject extends AspObject {

  //plot Main data
  public plotID: number = 0;
  isCorrelated: boolean = false;
  CorrelationType: enums.PlotCorr = 0;
  plotName: string = "";
  sensorLetter: string = "?";
  plotType: enums.PlotType;
  timeStamp: Date;
  timeStamplocal: Date;
  timeStr: string;
  is2D: boolean;

  //sensor data
  public sensorID: number = 0;
  sic: number = 0;
  sac: number = 0;
  public symbol: string = "plot-iff";
  public svgSymbol: string = "";

  // Dynamics
  range: number = 0;
  azimuth: number = 0;
  elevation: number = 0;

  //IFF SECTION
  iffAvailable: boolean = false;
  mode1Valid: boolean = false;
  mode1: number;
  mode2Valid: boolean = false;
  mode2: number;
  mode3Valid: boolean = false;
  mode3: number;
  mode4Valid: boolean = false;
  modeSValid: boolean = false;
  modeSAcIdent: string = "";
  modeSAddress: number = 0;
  modeSAltitude: number = 0;
  modeSSpeed: number = 0;
  modeCValid: boolean = false;
  modeC: number = 0;

  constructor(objectsPool: IObjectsPool, sensorID: number, plotID: number, correlated: boolean) {
    super(objectsPool, ObjectType.Plot, AspObject.generateId(ObjectType.Plot, sensorID, plotID));

    this.plotID = plotID;
    this.sensorID = sensorID;
    this.isCorrelated = correlated;

    this.sensorLetter = aspObjects.sensorsPool.getSensorLetterBySensorID(sensorID);
    if (this.sensorLetter == "") {
      this.sensorLetter = "?";
    }
    this.isActive = false; // will be activate when slot becomes current
  }

  handleMsg(msgObj: any): boolean {
    // do not exist yet...
    this.plotType = msgObj.PlotType;

    // correlation type
    this.CorrelationType = msgObj.CorrelationType;
    this.isCorrelated = false;
    switch (this.CorrelationType) {
      case enums.PlotCorr.NotRelevant:
        {
          this.symbol = "plot-cross";
          break;
        }
      case enums.PlotCorr.Ambiguous:
        {
          this.symbol = "plot-corr";
          this.isCorrelated = true;
          break;
        }
      case enums.PlotCorr.Correlated:
        {
          this.symbol = "plot-corr";
          this.isCorrelated = true;
          break;
        }
      case enums.PlotCorr.UnCorrelated:
        {
          this.symbol = "plot-uncorr";
          break;
        }
      case enums.PlotCorr.Tentative:
        {
          this.symbol = "plot-corr";
          this.isCorrelated = true;
          break;
        }
    }
    this.svgSymbol = utils.getPlaneSymbol(this.symbol);

    // 2D 3D
    if (msgObj.Sic && msgObj.Sac) {
      let sensor = aspObjects.sensorsPool.getSensorBySicSac(msgObj.Sic, msgObj.Sac);
      if(sensor)
        this.is2D = sensor.is2D;
    }

    // time
    this.timeStamplocal = new Date();
    const datetime = msgObj.Time.split('-');
    const date = datetime[0].split('.');
    const time = datetime[1].split(':');
    this.timeStamp = new Date(parseInt(date[2]) + 2000, parseInt(date[1]) - 1, parseInt(date[0]), time[0], time[1], time[2].split('.')[0], time[2].split('.')[1]);
    this.timeStr = units.datetime2Str(this.timeStamp, true);

    // sic sac
    this.sic = msgObj.Sic;
    this.sac = msgObj.Sac;

    // Dynamics
    let loc: Location = { altitude: msgObj.LocationAltitude, longitude: msgObj.LocationLong, latitude: msgObj.LocationLat };;
    this.updateDynamics((loc.longitude * units.RAD_TO_DEG) + aspSettings.deltaX,
      (loc.latitude * units.RAD_TO_DEG) + aspSettings.deltaY, loc.altitude);

    if (msgObj.Azimuth != null)
      this.azimuth = msgObj.Azimuth;
    if (msgObj.Elevation != null)
      this.elevation = msgObj.Elevation;
    if (msgObj.Range != null)
      this.range = msgObj.Range;

    //IFF Section
    if (msgObj.IFFAvailable) {
      if (msgObj.Mode1) {
        this.mode1Valid = true;
        this.mode1 = msgObj.Mode1;
      }
      if (msgObj.Mode2) {
        this.mode2Valid = true;
        this.mode2 = parseInt(msgObj.Mode2);
      }
      if (msgObj.Mode3) {
        this.mode3Valid = true;
        this.mode3 = parseInt(msgObj.Mode3);
      }
      if (msgObj.ModeSAcIdent) {
        this.modeSValid = true;
        this.modeSAcIdent = msgObj.ModeSAcIdent;
        this.modeSAddress = msgObj.ModeSAddress;
        this.modeSAltitude = msgObj.ModeSAltitude;
        this.modeSSpeed = msgObj.ModeSSpeed;

        //this.modeSNationality = msgObj.ModeSAcIdent;
      }
      if (msgObj.ModeC) {
        this.modeCValid = true;
        this.modeC = msgObj.ModeC;
      }
    }
    else {
      this.mode1Valid = false;
      this.mode2Valid = false;
      this.mode3Valid = false;
      this.modeSValid = false;
      this.modeCValid = false;
    }

    this.postHandleMsg(msgObj);

    this.notifyDataChange();

    return true;
  }

  protected postHandleMsg(msgObj: any) {
    // To be implemented if needed
  }

  // Get object title
  getTitle(): string {
    return 'Plot ' + this.sensorLetter + '/' + this.plotID;
  }

  private max: number = 500;
  private colorCss: any;
  private age: number = 0;
  private reps: number = this.max;
  // color for newmi drawing
  getColor() {
    this.reps++;
    if (this.reps > this.max) {
      this.reps = 0;
      let ageSec = (new Date().getTime() - this.timeStamplocal.getTime()) / 1000;
      this.age = (settings.userSettings.plotTrailLength - ageSec) / settings.userSettings.plotTrailLength;
      this.colorCss = aspSettings.colorOfPlot(this.CorrelationType, this.age);
    }
    return this.colorCss;
  }

  // color for css html 
  getCssColor() {
    return utils.newmiColorToString(this.getColor());
  }

  getSymbol() {
    return this.symbol;
  }

  // gets full path and the icon
  getSvgSymbol() {
    return this.svgSymbol;
  }
}
